import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="app-shell grain flex flex-col p-6 min-h-[100dvh]">
      <div className="flex-1 flex flex-col justify-center animate-fade-up">
        <h1 className="font-serif text-5xl">No worries.</h1>
        <p className="mt-4 text-muted-foreground max-w-md">
          You didn't upgrade — nothing was charged. Free DailyLock still gets you one exchange every day.
        </p>
        <div className="mt-10 flex gap-3">
          <Link to="/premium">
            <Button variant="outline" className="rounded-full h-12" data-testid="cancel-retry">See Premium again</Button>
          </Link>
          <Link to="/today">
            <Button className="rounded-full h-12 bg-primary hover:bg-primary/90" data-testid="cancel-home">Back to Today</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
